var map = {
	"./ILk_Vj-29lw8lI6XnQ3lq/logo-wt.png": 78642,
	"./NvlUxQ7ObrtsKbDxQuLRP/logo-wt.png": 4172,
	"./qJ9VP_krP4jhKGnCRxzP_/logo-wt.png": 23162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94067;